export class Quarters {
    rowNum: number;
    id: number;
    codigo: string;
    descripcion: string
}